<template>
  <div>
    <Dialog
        :dismissableMask="true"
        :style="{ width: '75vw' }"
        :modal="true"
        :visible.sync="show"
        @hide="closeDialog"
        :contentStyle="{overflow: 'visible'}"
    >
      <template #header>
        <i style=" transform: scale(1.7); " class="pi pi-book"></i>
        <h1>התקדמות בחומר</h1>
      </template>

      <div class="p-pt-4 p-fluid p-grid">

        <!--   lessonTime  -->
        <div class="p-field p-col-12 p-md-6">
          <label>זמן השיעור</label>
          <Dropdown
              :filter="true"
              v-model="newItem.time"
              :options="lessonTime"
              placeholder="בחר את זמן השיעור"
          >
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span>{{ slotProps.value.hebrewName }} </span>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
            <template #option="slotProps">
              <span>{{ slotProps.option.hebrewName }} </span>
            </template>
          </Dropdown>
        </div>


        <!--   subjectLesson  -->
        <div class="p-field p-col-12 p-md-6">
          <label>נושא השיעור</label>
          <Dropdown
              :filter="true"
              v-model="newItem.subject"
              :options="subjectLesson"
              placeholder="בחר את נושא השיעור"
          >
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span>{{ slotProps.value.hebrewName }} </span>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
            <template #option="slotProps">
              <span>{{ slotProps.option.hebrewName }} </span>
            </template>
          </Dropdown>
        </div>

        <!--   content  -->

        <div class="p-field p-col-12 p-md-6">
          <label>תוכן</label>

          <InputText type="text" v-model="newItem.content"/>
        </div>

        <!--   date  -->
        <div class="p-field p-col-12 p-md-6">
          <label>יום השיעור</label>

          <Calendar
              :showButtonBar="true"
              dateFormat="dd.mm.yy"
              v-model="newItem.date"
              placeholder="תאריך"
          />
        </div>

        <!-- grade-->
        <div class="p-field p-col-12 p-md-3">
          <label>כיתה</label>

          <Dropdown
              v-model="newItem.grade"
              :options="gradeOptions"
              placeholder="בחר כיתה"
          >
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span>{{ slotProps.value.hebrewName }}</span>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
            <template #option="slotProps">
              <span>{{ slotProps.option.hebrewName }}</span>
            </template>
          </Dropdown>
        </div>


      </div>

      <template #footer>
        <Button
            label="ביטול"
            icon="pi pi-times"
            @click="closeDialog"
            class="p-button-secondary"
        />

        <Button v-if="validateToPost" class="p-button-success" label="הוספה" icon="pi pi-check" @click="post"/>
        <Button v-else disabled="disabled" class="p-button-success" label="הוספה" icon="pi pi-check"/>

      </template>
    </Dialog>
  </div>
</template>

<script>
import Service from "../../service/Service";
import {mapState} from "vuex";

const {v4: uuidv4} = require("uuid");

export default {
  service: null,
  props: {
    show: Boolean,
  },
  created() {

    this.service = new Service();
    this.setNewItwmFields();
  },
  computed: {
    validateToPost() {
      if (this.newItem.subject === null) return false
      if (this.newItem.date === null) return false
      if (this.newItem.time === null) return false
      if (this.newItem.grade === null) return false
      return true
    },
    ...mapState(["presenceStatus", "pupils", "lessonTime", 'user', "subjectLesson", "gradeOptions"]),
  },
  data() {
    return {
      newItem: null,
      postLock: false
    };
  },

  methods: {
    getGradeObj(gradeId) {
      return this.gradeOptions.find((grade) => (grade.id === gradeId));
    },
    setNewItwmFields() {
      this.newItem = {
        id: uuidv4(),
        date: new Date(),
        time: null,
        content: null,
        subject: null,
        user: null,
        grade: null,
      };
      if (this.user.grade !== null) {
        this.newItem.grade = this.getGradeObj(this.user.grade)
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {
      let validate = true;
      // for (const key in this.newItem) {
      //   if (this.newItem[key] === null) {
      //     validate = false;
      //   }
      // }
      if (!this.postLock) {


        if (validate === true) {
          this.postLock = true

          const lessonTimeObj = JSON.parse(JSON.stringify(this.newItem.time))
          const subjectLessonObj = JSON.parse(JSON.stringify(this.newItem.subject))
          const gradeObj = JSON.parse(JSON.stringify(this.newItem.grade))

          const userObj = JSON.parse(JSON.stringify(this.newItem))
          userObj.date = Date.parse(userObj.date)
          userObj.subject = userObj.subject.id
          userObj.time = userObj.time.id
          userObj.grade = userObj.grade.id
          userObj.user = this.user.id

          await this.service
              .post(userObj, 'study')
              .then(() => {
                userObj.subject = subjectLessonObj;
                userObj.time = lessonTimeObj;
                userObj.grade = gradeObj;
                userObj.user = this.user;
                this.$emit("addItem", userObj);
                this.setNewItwmFields();
                this.openNotification(
                    "success",
                    `מעולה`,
                    `המשתמש התתוסף במערכת`
                );
                this.postLock = false
                this.closeDialog();
              })
              .catch(() => {
                this.openNotification(
                    "danger",
                    `אופס`,
                    `אולי קיים כבר משתמש עם ת.ז. זהה`
                );
                this.postLock = false

              });
        } else {
          this.openNotification(
              "danger",
              `אופס`,
              `חסרים כמה שדות למילוי`
          );
        }
      }
    },
    openNotification(color, title, text, position = "right-left", duration = 3000) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>

<style>
</style>